import { getExtension } from "client_legacy/Documents/path";
import { WebDavConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

export interface OpenPossibilities {
	wopi: boolean;
	browser: boolean;
	imagePreviewDialog: boolean;
	local: boolean;
	externalUrl: boolean;
}

export class OpenFilePossibilitiesProvider {

	public getForFileName(
		fileName: string,
		webDavConfiguration: WebDavConfiguration
	): OpenPossibilities {
		const extension: string = getExtension(fileName);
		return this.getForExtension(extension, webDavConfiguration);
	}

	public getForExtension(
		extension: string,
		webDavConfiguration: WebDavConfiguration
	): OpenPossibilities {
		switch (extension.toLowerCase()) {
			case ".doc":
			case ".docx":
			case ".dotx":
			case ".docm":
			case ".dotm":
			case ".csv":
			case ".xls":
			case ".xlsb":
			case ".xlsx":
			case ".xlsm":
			case ".potx":
			case ".pptx":
			case ".ppt":
			case ".pptm":
				return {
					wopi: webDavConfiguration.wopi.isEnabled,
					browser: false,
					local: webDavConfiguration.localApp.isEnabled,
					imagePreviewDialog: false,
					externalUrl: false
				};
			case ".one":
				return {
					wopi: false,
					browser: false,
					local: webDavConfiguration.localApp.isEnabled,
					imagePreviewDialog: false,
					externalUrl: false
				};
			case ".wopitest":
				return {
					wopi: true,
					browser: false,
					local: false,
					imagePreviewDialog: false,
					externalUrl: false
				};
			case ".png":
			case ".jpg":
			case ".jpeg":
			case ".gif":
			case ".bmp":
				return {
					wopi: false,
					browser: false,
					local: false,
					imagePreviewDialog: true,
					externalUrl: false
				};
			case ".url":
				return {
					wopi: false,
					browser: false,
					local: false,
					imagePreviewDialog: false,
					externalUrl: true
				};
			default:
				return {
					wopi: false,
					// Unlike the SP implementation we offer online for all files which might result in an inline-download
					browser: true,
					local: false,
					imagePreviewDialog: false,
					externalUrl: false
				};
		}
	}
}